import DraggableModal from 'components/organisms/draggableModal';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

interface SummaryModalProps {
  open: boolean;
  subTitle: string;
  text?: string;
  onCancel: () => void;
}

const loremText =
  'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus, maxime! Impedit minus quidem reiciendis mollitia voluptatem sequi excepturi earum eveniet omnis animi eum velit vel, eaque enim autem ipsam neque sapiente. Labore quod recusandae illo facilis aliquid blanditiis. Officiis ut minus eos magni reiciendis quia obcaecati doloremque deleniti, esse cupiditate ipsam, natus laboriosam sunt repellat necessitatibus dicta dolor consectetur, assumenda quos numquam eum sequi. Eum, ab, magni illum ipsa neque consequuntur laborum autem nulla, nisi quae enim cum aut sapiente voluptatibus? Accusantium at sint dolores, consectetur provident, ex porro sapiente vero mollitia ratione quasi excepturi, obcaecati eveniet. Perspiciatis id facere vel, fugiat in quis tempora ducimus labore obcaecati excepturi assumenda nemo at veniam, et, numquam tempore corporis inventore esse voluptatum eligendi magnam? Exercitationem voluptates dolore minima, dignissimos quasi, blanditiis numquam corporis architecto quidem cum tenetur natus adipisci qui quod nemo ullam earum ducimus tempore fugiat porro enim, quos pariatur unde possimus? Earum eligendi quia inventore maiores cum sapiente suscipit pariatur blanditiis magni consequatur recusandae dolorum adipisci nostrum, nesciunt nam esse explicabo, quas voluptate, placeat beatae quos distinctio. Quos amet quod incidunt dicta debitis culpa recusandae quibusdam. Consequatur cum, asperiores veritatis inventore sapiente, placeat sequi error est odio rerum dolorem commodi.';

const SummaryModal: FC<SummaryModalProps> = ({
  open,
  onCancel,
  text = loremText,
  subTitle,
}) => {
  if (!open) return null;

  const { t } = useTranslation();

  return (
    <DraggableModal
      title={t('patientSnapshot.summary')}
      subTitle={subTitle}
      isOpen={open}
      toggle={onCancel}
      bodyClassName={s['modal-body']}
      modalClassName={s.modal}
      footer={false}
    >
      <p>{text}</p>
    </DraggableModal>
  );
};
export default SummaryModal;
